import { render } from "./POSList.vue?vue&type=template&id=522dacec"
import script from "./POSList.vue?vue&type=script&lang=js"
export * from "./POSList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__